import Vue from 'vue';
import VeeValidate, { Validator } from 'vee-validate';
import pt_BR from 'vee-validate/dist/locale/pt_BR';

Validator.localize('pt_BR', pt_BR);
Vue.use(VeeValidate, { fieldsBagName: 'formFields', locale: 'pt_BR' });

export default Vue;